import { useEffect, useState } from 'react';
import axios from 'axios';
import CONFIG from '../constanta/config';
import { read, utils, writeFileXLSX } from 'xlsx';
import moment from 'moment';

const PageReportReset = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    setLoading(true);
    axios
      .get(CONFIG.URL_DISDUK + '/peserta-checkin?t=' + Date.now())
      .then((res) => {
        if (res.data.status === 'SUCCESS') {
          setData(res.data.data);

        } else {
          setMsg('Gagal mengambil data!');
        }
      })
      .catch(() => setMsg('Terjadi kesalahan!'))
      .finally(() => setLoading(false));
  };

  const handleReset = () => {
    setLoading(true);
    axios
      .post(CONFIG.URL_DISDUK + '/checkin/reset-all')
      .then((res) => {
        if (res.data.status === 'SUCCESS') {
          setMsg('Suskes Reset!');
          fetchData();
        } else {
          setMsg('Gagal Reset');
        }
      })
      .catch(() => setMsg('Terjadi kesalahan!'))
      .finally(() => setLoading(false));
  };

  return (
    <div className="h-screen bg-gray-100 px-3 py-8 flex justify-center overflow-hidden">
      <button
        disabled={loadingDownload}
        onClick={() => handleReset()}
        className="px-4 py-2 rounded-xl bg-red-500 fixed bottom-10 md:bottom-auto md:top-12 md:right-12 text-white font-bold">
        Reset Semua Data Checkin
      </button>

      <div className="bg-white w-full shadow-md rounded-xl p-5 h-full">
        <h2 className="md:text-2xl font-bold mb-5 text-center">
          Daftar Checkin Peserta Rakor Data dan Teknologi Informasi Pendidikan
          2025
        </h2>

        {loading && (
          <p className="text-center text-blue-600 font-semibold">
            Mengambil data...
          </p>
        )}

        {msg && (
          <p className="text-center text-red-600 font-semibold mb-3">{msg}</p>
        )}

        {!loading && data.length > 0 && (
          <div className="relative overflow-scroll h-[85%] md:h-[93%]">
            <table className="min-w-full h-full  border border-gray-300 rounded-lg">
              <thead className="bg-blue-600 text-white text-xs">
                <tr>
                  <th className="px-3 py-2">No</th>
                  <th className="px-3 py-2 text-left whitespace-nowrap">
                    Waktu Checkin
                  </th>
                  <th className="px-3 py-2 text-left whitespace-nowrap">
                    Lama Menginap
                  </th>
                  <th className="px-3 py-2 text-left whitespace-nowrap">
                    Tanggal Daftar
                  </th>
                  <th className="px-3 py-2 text-left whitespace-nowrap">
                    Nama Lengkap
                  </th>
                  <th className="px-3 py-2 text-left">NIP</th>
                  <th className="px-3 py-2 text-left w-96">Jabatan</th>
                  <th className="px-3 py-2 text-left">Pangkat</th>
                  <th className="px-3 py-2 text-left">NPWP</th>
                  <th className="px-3 py-2 text-left whitespace-nowrap">
                    Jenis Kelamin
                  </th>
                  <th className="px-3 py-2 text-left">Email</th>
                  <th className="px-3 py-2 text-left">Telepon</th>
                  <th className="px-3 py-2 text-left whitespace-nowrap">
                    Asal Provinsi
                  </th>
                  <th className="px-3 py-2 text-left whitespace-nowrap">
                    Asal Instansi
                  </th>
                  <th className="px-3 py-2 text-left whitespace-nowrap">
                    Unit Kerja
                  </th>
                  <th className="px-3 py-2 text-left whitespace-nowrap">
                    Alamat Unit Kerja
                  </th>
                  <th className="px-3 py-2 text-left">Kehadiran</th>
                  <th className="px-3 py-2 text-left">Tiket</th>
                  <th className="px-3 py-2 text-left">Tanda Tangan</th>

                  {/* Kolom baru transportasi */}
                  <th className="px-3 py-2 text-left">Transportasi</th>

                  {/* Pesawat */}
                  <th className="px-3 py-2 text-left whitespace-nowrap">
                    Maskapai Berangkat
                  </th>
                  <th className="px-3 py-2 text-left">Jam Berangkat Pesawat</th>
                  <th className="px-3 py-2 text-left whitespace-nowrap">
                    Bandara Berangkat
                  </th>

                  <th className="px-3 py-2 text-left whitespace-nowrap">
                    Maskapai Pulang
                  </th>
                  <th className="px-3 py-2 text-left">Jam Pulang Pesawat</th>
                  <th className="px-3 py-2 text-left whitespace-nowrap">
                    Bandara Pulang
                  </th>

                  {/* Kereta */}
                  <th className="px-3 py-2 text-left">Jam Berangkat Kereta</th>
                  <th className="px-3 py-2 text-left whitespace-nowrap">
                    Stasiun Berangkat
                  </th>
                  <th className="px-3 py-2 text-left">Jam Pulang Kereta</th>
                  <th className="px-3 py-2 text-left whitespace-nowrap">
                    Stasiun Pulang
                  </th>

                  <th className="px-3 py-2 text-left">QR CODE</th>
                </tr>
              </thead>

              <tbody>
                {data.map((item, i) => (
                  <tr
                    key={i}
                    className={`${
                      i % 2 === 0 ? 'bg-gray-50' : 'bg-white'
                    } border-b`}>
                    <td className="px-3 py-2 text-center whitespace-nowrap">
                      {i + 1}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap text-center">
                      {item.checkin_time ?? '-'}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap text-center">
                      {item.lama_menginap ?? '-'}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap">
                      {item.created_at}
                    </td>
                    <td className="px-3 py-2">{item.nama_lengkap}</td>
                    <td className="px-3 py-2">{item.nip}</td>
                    <td className="px-3 py-2 w-96">{item.jabatan}</td>
                    <td className="px-3 py-2 whitespace-nowrap">
                      {item.pangkat}
                    </td>
                    <td className="px-3 py-2">{item.npwp}</td>
                    <td className="px-3 py-2">{item.jenis_kelamin}</td>
                    <td className="px-3 py-2">{item.email}</td>
                    <td className="px-3 py-2">{item.telepon}</td>
                    <td className="px-3 py-2 whitespace-nowrap">
                      {item.asal_provinsi}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap">
                      {item.asal_instansi}
                    </td>
                    <td className="px-3 py-2">{item.nama_unit_kerja}</td>
                    <td className="px-3 py-2">{item.alamat_unit_kerja}</td>

                    <td
                      className={`px-3 py-2 font-semibold ${
                        item.kehadiran === 'Hadir'
                          ? 'text-green-600'
                          : 'text-red-600'
                      }`}>
                      {item.kehadiran}
                    </td>

                    <td
                      className={`px-3 py-2 font-semibold ${
                        item.tiket === 'Sudah'
                          ? 'text-green-600'
                          : 'text-red-600'
                      }`}>
                      {item.tiket}
                    </td>

                    {/* Signature */}
                    <td className="px-3 py-2">
                      {item.signature_url ? (
                        <a
                          href={`${CONFIG.URL_MEDIA}/${item.signature_url}`}
                          target="_blank"
                          rel="noreferrer"
                          className="text-blue-600 underline">
                          Lihat
                        </a>
                      ) : (
                        '-'
                      )}
                    </td>

                    <td className="px-3 py-2">
                      {item.transportasi === 'undefined'
                        ? '-'
                        : item.transportasi}
                    </td>

                    {/* Pesawat */}
                    <td className="px-3 py-2">
                      {item.maskapai_berangkat === ''
                        ? '-'
                        : item.maskapai_berangkat}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap">
                      {item.jam_berangkat_pesawat
                        ? item.jam_berangkat_pesawat.replace('T', ' ')
                        : '-'}
                    </td>
                    <td className="px-3 py-2">
                      {item.bandara_berangkat === ''
                        ? '-'
                        : item.bandara_berangkat}
                    </td>

                    <td className="px-3 py-2">
                      {item.maskapai_pulang === '' ? '-' : item.maskapai_pulang}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap">
                      {item.jam_pulang_pesawat
                        ? item.jam_pulang_pesawat.replace('T', ' ')
                        : '-'}
                    </td>
                    <td className="px-3 py-2">
                      {item.bandara_pulang === '' ? '-' : item.bandara_pulang}
                    </td>

                    {/* Kereta */}
                    <td className="px-3 py-2 whitespace-nowrap">
                      {item.jam_berangkat_kereta
                        ? item.jam_berangkat_kereta.replace('T', ' ')
                        : '-'}
                    </td>
                    <td className="px-3 py-2">
                      {item.stasiun_berangkat === ''
                        ? '-'
                        : item.stasiun_berangkat}
                    </td>

                    <td className="px-3 py-2 whitespace-nowrap">
                      {item.jam_pulang_kereta
                        ? item.jam_pulang_kereta.replace('T', ' ')
                        : '-'}
                    </td>
                    <td className="px-3 py-2">
                      {item.stasiun_pulang === '' ? '-' : item.stasiun_pulang}
                    </td>

                    <td className="px-3 py-2">
                      {item.kehadiran === 'Hadir' ? (
                        <a
                          href={`https://rdtip2025.event-ku.com/qrcode?code=${item.qr_code}`}
                          target="_blank"
                          rel="noreferrer"
                          className="text-blue-600 underline">
                          Lihat
                        </a>
                      ) : (
                        '-'
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {!loading && data.length === 0 && (
          <p className="text-center text-gray-600 mt-3">
            Tidak ada data peserta
          </p>
        )}
      </div>
    </div>
  );
};

export default PageReportReset;
